import {Button} from '@/components/ui/button/Button'
import {useAsync} from '@/hooks/useAsync'
import {useTranslation} from '@/translations/i18n'
import {errorHandler} from '@/utilities/helpers'
import {httpCancelEmailChange} from '../../services/account.http'
import {useAuthStore} from '@/features/auth/store/store'

interface CancelEmailChangeButtonProps {
    isLoading: boolean
    userId: string
}

export const CancelEmailChangeButton = ({isLoading, userId}: CancelEmailChangeButtonProps) => {
    const {t} = useTranslation()
    const cancelEmailChangeAsync = useAsync()
    const setAuthUser = useAuthStore(state => state.setAuthUser)

    const handleCancelEmailChange = async () => {
        try {
            const response = await cancelEmailChangeAsync.run(httpCancelEmailChange({urlParams: {userId}}))
            setAuthUser(response.data)
        } catch (error) {
            errorHandler(error)
        }
    }

    return (
        <Button variant="tertiary" shape="text" disabled={isLoading} onClick={handleCancelEmailChange}>
            {t('account:cancel_email_change')}
        </Button>
    )
}
